import { Labor } from "./Labor";
import { useLaborInit, useLaborUpdate } from "./hooks";
import { SelectedSupplierProvider } from "./context";
import { LaborSupplierComparison } from "./LaborSupplierComparison";
import { LaborSkeleton } from "./skeletons";
import { motion } from "framer-motion";

interface ILaborComponent {
    measurements: any;
    setIsNextStageEligible: any;
    overrideCalculations: boolean;
}

export function LaborComponent({ measurements, setIsNextStageEligible, overrideCalculations }: ILaborComponent) {
    const { laborItems, cart, priceRanges, laborSchema, isLoading } = useLaborInit(measurements);

    if (isLoading) {
        return <LaborSkeleton />;
    }

    return (
        <SelectedSupplierProvider>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
            >
                <LaborComponentContent
                    laborItems={laborItems}
                    cart={cart}
                    priceRanges={priceRanges}
                    measurements={measurements}
                    laborSchema={laborSchema}
                    setIsNextStageEligible={setIsNextStageEligible}
                    overrideCalculations={overrideCalculations}
                />
            </motion.div>
        </SelectedSupplierProvider>
    );
}

interface ILaborComponentContent {
    laborItems: any[];
    cart: any[];
    priceRanges: any;
    measurements: any;
    laborSchema: any[];
    setIsNextStageEligible: any;
    overrideCalculations: boolean;
}

function LaborComponentContent({
    laborItems,
    cart,
    priceRanges,
    measurements,
    laborSchema,
    setIsNextStageEligible,
    overrideCalculations,
}: ILaborComponentContent) {
    const { selectedValues, handleQuantityChange, handleRemoveLaborItem } = useLaborUpdate(
        measurements,
        laborSchema,
        [],
        cart,
        overrideCalculations,
    );

    return (
        <>
            <Labor
                laborItems={laborItems}
                selectedValues={selectedValues}
                onQuantityChange={handleQuantityChange}
                onRemove={handleRemoveLaborItem}
                priceRanges={priceRanges}
            />
            <LaborSupplierComparison selectedValues={selectedValues} setIsNextStageEligible={setIsNextStageEligible} />
        </>
    );
}
